<editable [isClosingEditModeDisabled]="isModalOpen" (modeChange)="onModeChanged($event)">
  <ng-template leViewMode>
    <app-expression-formula-view [expression]="expression"></app-expression-formula-view>
  </ng-template>
  <ng-template leEditMode>
    <ng-container [ngSwitch]="readonly">
      <ng-container *ngSwitchCase="true">
        <div *ngIf="expression" class="expression-formula text-break text-wrap" [title]="expression.Comments || ''">{{expression.Formula}}</div>
        <div *ngIf="expression?.ExternalFormula" class="expression-formula text-break text-wrap text-primary fst-italic" [title]="expression.Comments || ''">{{expression.ExternalFormula}}</div>
      </ng-container>
      <ng-container *ngSwitchCase="false">
        <ng-container *ngIf="expression">
          <div style="margin: -0.3rem">
            <ace class="ace-transparent-background" [config]="config" [(value)]="expression.Formula" (valueChange)="onChanged$.next(true)">
            </ace>
            <hr class="my-2" *ngIf="expression.ExternalFormula">
            <ace class="ace-transparent-background" [config]="config" [(value)]="expression.ExternalFormula" (valueChange)="onExternalChanged$.next(true)" *ngIf="expression.ExternalFormula">
            </ace>
          </div>
        </ng-container>
        <div class="cell-action">
          <button class="btn btn-outline-default btn-sm" type="button" (click)="edit()">
            <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
            </svg>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</editable>
